import React, { ReactNode } from "react";
// Protected Route

// Default
import { Navigate } from "react-router-dom";

// Types
interface ProtectedRouteProps {
  children: ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const isAuthenticated = (): boolean => {
    return !!localStorage.getItem("authToken");
  };

  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
